import CreatedLeadList from "./createdLeadList";
export default CreatedLeadList;